import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=77b9262c&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=ts&"
export * from "./navigation.vue?vue&type=script&lang=ts&"
import style0 from "./navigation.vue?vue&type=style&index=0&id=77b9262c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b9262c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b9262c')) {
      api.createRecord('77b9262c', component.options)
    } else {
      api.reload('77b9262c', component.options)
    }
    module.hot.accept("./navigation.vue?vue&type=template&id=77b9262c&scoped=true&", function () {
      api.rerender('77b9262c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/pagination/simple/navigation.vue"
export default component.exports